import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Agent {
  agent_id: string;
  agent_name: string;
  status: 'draft' | 'testing' | 'active' | 'inactive';
  language?: string;
  voice?: string;
  personality_prompt?: string;
  greeting_message?: string;
  fallback_message?: string;
  created_at: string;
  updated_at: string;
}

interface AgentsState {
  agents: Agent[];
  selectedAgent: Agent | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: AgentsState = {
  agents: [],
  selectedAgent: null,
  isLoading: false,
  error: null,
};

export const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    setAgents(state, action: PayloadAction<Agent[]>) {
      state.agents = action.payload;
    },
    setSelectedAgent(state, action: PayloadAction<Agent | null>) {
      state.selectedAgent = action.payload;
    },
    addAgent(state, action: PayloadAction<Agent>) {
      state.agents.unshift(action.payload);
    },
    updateAgent(state, action: PayloadAction<Agent>) {
      const idx = state.agents.findIndex((a) => a.agent_id === action.payload.agent_id);
      if (idx !== -1) state.agents[idx] = action.payload;
      if (state.selectedAgent?.agent_id === action.payload.agent_id) {
        state.selectedAgent = action.payload;
      }
    },
    removeAgent(state, action: PayloadAction<string>) {
      state.agents = state.agents.filter((a) => a.agent_id !== action.payload);
      if (state.selectedAgent?.agent_id === action.payload) {
        state.selectedAgent = null;
      }
    },
    setAgentsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setAgentsError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setAgents,
  setSelectedAgent,
  addAgent,
  updateAgent,
  removeAgent,
  setAgentsLoading,
  setAgentsError,
} = agentsSlice.actions;
